module.exports = __webpack_public_path__ + "static/media/Categoria6Agroindustrias.f2f1a18c.jpg";